// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DatePickerComponent_otr {
	display: flex;
	min-height: 380px;
}
.DatePickerComponent_otr .react-datepicker {
	border: none;
	border-radius: 0;
	-webkit-border-radius: 0;
	-moz-border-radius: 0;
	-ms-border-radius: 0;
	-o-border-radius: 0;
}
.DatePickerComponent_otr .react-datepicker__header {
	padding: 0;
}

.react-datepicker__day--disabled {
	pointer-events: none;
}
.DatePickerComponent_otr .react-datepicker,
.DatePickerComponent_otr .react-datepicker__month-container,
.DatePickerComponent_otr .react-datepicker__day-name,
.DatePickerComponent_otr .react-datepicker__day {
	width: 100%;
}
.DatePickerComponent_otr .react-datepicker__day-names,
.DatePickerComponent_otr .react-datepicker__week {
	display: flex;
	align-items: stretch;
}
.DatePickerComponent_otr .react-datepicker__day-name,
.DatePickerComponent_otr .react-datepicker__month,
.DatePickerComponent_otr .react-datepicker__day,
.DatePickerComponent_otr .react-datepicker__day-names {
	margin: 0;
}
.DatePickerComponent_otr .react-datepicker__header {
	background-color: transparent;
	border: none;
	border-radius: 0;
	-webkit-border-radius: 0;
	-moz-border-radius: 0;
	-ms-border-radius: 0;
	-o-border-radius: 0;
}
.DatePickerComponent_otr .react-datepicker__current-month {
	font-size: 32px;
	line-height: 44px;
	font-family: Verdana !important;
	font-weight: 300;
	padding: 16px 8px;
	color: var(--dark-text-color);
}
.DatePickerComponent_otr .react-datepicker__navigation {
	width: 44px;
	height: 44px;
	top: 16px;
}
.DatePickerComponent_otr .react-datepicker__navigation-icon {
	top: 2px;
}
.DatePickerComponent_otr .react-datepicker__navigation--previous {
	left: 90px;
}
@media (max-width: 575px) {
	.DatePickerComponent_otr .react-datepicker__navigation--previous {
		left: 50px;
	}
}
@media (max-width: 450px) {
	.DatePickerComponent_otr .react-datepicker__navigation--previous {
		left: 30px;
	}
}
@media (max-width: 390px) {
	.DatePickerComponent_otr .react-datepicker__navigation--previous {
		left: 10px;
	}
}
.DatePickerComponent_otr .react-datepicker__navigation--next {
	right: 90px;
}
@media (max-width: 575px) {
	.DatePickerComponent_otr .react-datepicker__navigation--next {
		right: 50px;
	}
}
@media (max-width: 450px) {
	.DatePickerComponent_otr .react-datepicker__navigation--next {
		right: 30px;
	}
}
@media (max-width: 390px) {
	.DatePickerComponent_otr .react-datepicker__navigation--next {
		right: 10px;
	}
}
.DatePickerComponent_otr .react-datepicker__month {
	display: flex;
	flex-direction: column;
	gap: 10px 0;
	padding: 10px 0 24px 0;
}

.DatePickerComponent_otr .react-datepicker__day-name {
	font-size: 12px;
	line-height: 28px;
	font-weight: 500;
	font-family: Verdana !important;
	color: var(--black-color);
}
.DatePickerComponent_otr .react-datepicker__day {
	position: relative;
	font-size: 16px;
	line-height: 32px;
	font-family: Verdana !important;
	font-weight: 500;
	z-index: 2;
	transition: 0.3s;
	-webkit-transition: 0.3s;
	-moz-transition: 0.3s;
	-ms-transition: 0.3s;
	-o-transition: 0.3s;
}
.DatePickerComponent_otr .react-datepicker__day:hover::after {
	background-color: var(--primary-color);
}
.DatePickerComponent_otr .react-datepicker__day::after {
	content: "";
	position: absolute;
	width: 32px;
	height: 32px;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	-webkit-transform: translate(-50%, -50%);
	-moz-transform: translate(-50%, -50%);
	-ms-transform: translate(-50%, -50%);
	-o-transform: translate(-50%, -50%);
	border-radius: 100%;
	-webkit-border-radius: 100%;
	-moz-border-radius: 100%;
	-ms-border-radius: 100%;
	-o-border-radius: 100%;
	transition: 0.3s;
	-webkit-transition: 0.3s;
	-moz-transition: 0.3s;
	-ms-transition: 0.3s;
	-o-transition: 0.3s;
	background-color: transparent;
	z-index: -1;
}
.DatePickerComponent_otr .react-datepicker__day--selected::after {
	background-color: var(--primary-color);
}
.DatePickerComponent_otr .react-datepicker__day:hover,
.DatePickerComponent_otr .react-datepicker__day--selected,
.react-datepicker__day--keyboard-selected,
.react-datepicker__month-text--keyboard-selected,
.react-datepicker__quarter-text--keyboard-selected,
.react-datepicker__year-text--keyboard-selected {
	background: transparent !important;
}
.DatePickerComponent_otr .react-datepicker__day:hover {
	color: var(--white-color);
}

.DatePickerComponent_otr .react-datepicker__day--outside-month {
	opacity: 0.3;
}

.AppointmentCalendar_otr {
	height: 100%;
}

.date_radio_otr {
	background: var(--date-radio-bg);
	padding: 16px 24px;
	/* height: calc(100vh - 555px); */
	min-height: calc(100vh - 598px);
	max-height: -moz-fit-content;
	max-height: fit-content;
}
.date_radio_otr .date_text {
	color: var(--desc-color2);
	font-size: 14px;
	line-height: 24px;
	font-family: "Poppins", sans-serif;
	font-weight: 400;
	margin-bottom: 12px;
	letter-spacing: 0.01071em;
}
.date_check_group_wrapper {
	width: 100%;
	overflow-x: auto;
}
.date_radio_otr .radio_check_group {
	display: flex;
	flex-wrap: wrap;
	gap: 20px 0;
	min-width: 450px;
}

.time_slot_radio_btn_wrapper {
	width: 50%;
}

.radio_check_group .ant-radio-wrapper {
	width: 100%;
	margin-inline-end: 0 !important;
}
@media (max-width: 575px) {
	.date_radio_otr {
		background: var(--date-radio-bg);
		padding: 16px 24px;
		height: -moz-fit-content;
		height: fit-content;
	}

	.date_radio_otr .radio_check_group {
		padding-bottom: 20px;
		gap: 20px;
	}

	.time_slot_radio_btn_wrapper {
		background-color: #fff;
		border-radius: 16px;
		width: 215px;
		display: flex;
		justify-content: center;
		align-items: center;
		height: 55px;
	}
	.radio_check_group .ant-radio-wrapper {
		width: auto;
	}
}
.radio_check_group .ant-radio-wrapper-checked .ant-radio-inner {
	border: 2px solid var(--primary-color) !important;
}
.radio_check_group .ant-radio-wrapper-checked .ant-radio-inner::after {
	top: 50%;
	left: 51%;
	background-color: var(--primary-color) !important;
	transform: translate(-50%, -50%);
	-webkit-transform: translate(-50%, -50%);
	-moz-transform: translate(-50%, -50%);
	-ms-transform: translate(-50%, -50%);
	-o-transform: translate(-50%, -50%);
	margin-block-start: 0;
	margin-inline-start: 0;
	width: 10px;
	height: 10px;
}
.radio_check_group .ant-radio-wrapper:nth-child(even) .ant-radio-inner::after {
	left: 50%;
}
.radio_check_group .ant-radio-wrapper:nth-child(even) {
	justify-content: end;
}
.radio_check_group .ant-radio-wrapper .ant-radio-input,
.radio_check_group .ant-radio-wrapper .ant-radio-inner {
	width: 20px;
	height: 20px;
	margin: 0 !important;
}
.radio_check_group .ant-radio-wrapper .ant-radio-inner {
	border: 2px solid var(--radio-border-color);
	background-color: var(--date-radio-bg);
}
.radio_check_group .ant-radio-wrapper span:nth-child(2) {
	font-size: 16px;
	line-height: 24px;
	font-family: "Poppins", sans-serif;
	font-weight: 400;
	letter-spacing: 0.00938em;
}

.noslots_response {
	padding-top: 1rem;
	display: block;
	font-size: 1rem !important;
	line-height: 1.5rem;
	font-style: italic;
	letter-spacing: 0.02957rem;
	color: rgb(139, 0, 0);
}
`, "",{"version":3,"sources":["webpack://./src/Components/AppointmentCalendar/AppointmentCalendar.css"],"names":[],"mappings":"AAAA;CACC,aAAa;CACb,iBAAiB;AAClB;AACA;CACC,YAAY;CACZ,gBAAgB;CAChB,wBAAwB;CACxB,qBAAqB;CACrB,oBAAoB;CACpB,mBAAmB;AACpB;AACA;CACC,UAAU;AACX;;AAEA;CACC,oBAAoB;AACrB;AACA;;;;CAIC,WAAW;AACZ;AACA;;CAEC,aAAa;CACb,oBAAoB;AACrB;AACA;;;;CAIC,SAAS;AACV;AACA;CACC,6BAA6B;CAC7B,YAAY;CACZ,gBAAgB;CAChB,wBAAwB;CACxB,qBAAqB;CACrB,oBAAoB;CACpB,mBAAmB;AACpB;AACA;CACC,eAAe;CACf,iBAAiB;CACjB,+BAA+B;CAC/B,gBAAgB;CAChB,iBAAiB;CACjB,6BAA6B;AAC9B;AACA;CACC,WAAW;CACX,YAAY;CACZ,SAAS;AACV;AACA;CACC,QAAQ;AACT;AACA;CACC,UAAU;AACX;AACA;CACC;EACC,UAAU;CACX;AACD;AACA;CACC;EACC,UAAU;CACX;AACD;AACA;CACC;EACC,UAAU;CACX;AACD;AACA;CACC,WAAW;AACZ;AACA;CACC;EACC,WAAW;CACZ;AACD;AACA;CACC;EACC,WAAW;CACZ;AACD;AACA;CACC;EACC,WAAW;CACZ;AACD;AACA;CACC,aAAa;CACb,sBAAsB;CACtB,WAAW;CACX,sBAAsB;AACvB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,+BAA+B;CAC/B,yBAAyB;AAC1B;AACA;CACC,kBAAkB;CAClB,eAAe;CACf,iBAAiB;CACjB,+BAA+B;CAC/B,gBAAgB;CAChB,UAAU;CACV,gBAAgB;CAChB,wBAAwB;CACxB,qBAAqB;CACrB,oBAAoB;CACpB,mBAAmB;AACpB;AACA;CACC,sCAAsC;AACvC;AACA;CACC,WAAW;CACX,kBAAkB;CAClB,WAAW;CACX,YAAY;CACZ,QAAQ;CACR,SAAS;CACT,gCAAgC;CAChC,wCAAwC;CACxC,qCAAqC;CACrC,oCAAoC;CACpC,mCAAmC;CACnC,mBAAmB;CACnB,2BAA2B;CAC3B,wBAAwB;CACxB,uBAAuB;CACvB,sBAAsB;CACtB,gBAAgB;CAChB,wBAAwB;CACxB,qBAAqB;CACrB,oBAAoB;CACpB,mBAAmB;CACnB,6BAA6B;CAC7B,WAAW;AACZ;AACA;CACC,sCAAsC;AACvC;AACA;;;;;;CAMC,kCAAkC;AACnC;AACA;CACC,yBAAyB;AAC1B;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,gCAAgC;CAChC,kBAAkB;CAClB,iCAAiC;CACjC,+BAA+B;CAC/B,4BAAuB;CAAvB,uBAAuB;AACxB;AACA;CACC,yBAAyB;CACzB,eAAe;CACf,iBAAiB;CACjB,kCAAkC;CAClC,gBAAgB;CAChB,mBAAmB;CACnB,yBAAyB;AAC1B;AACA;CACC,WAAW;CACX,gBAAgB;AACjB;AACA;CACC,aAAa;CACb,eAAe;CACf,WAAW;CACX,gBAAgB;AACjB;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,WAAW;CACX,+BAA+B;AAChC;AACA;CACC;EACC,gCAAgC;EAChC,kBAAkB;EAClB,wBAAmB;EAAnB,mBAAmB;CACpB;;CAEA;EACC,oBAAoB;EACpB,SAAS;CACV;;CAEA;EACC,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;CACb;CACA;EACC,WAAW;CACZ;AACD;AACA;CACC,iDAAiD;AAClD;AACA;CACC,QAAQ;CACR,SAAS;CACT,iDAAiD;CACjD,gCAAgC;CAChC,wCAAwC;CACxC,qCAAqC;CACrC,oCAAoC;CACpC,mCAAmC;CACnC,qBAAqB;CACrB,sBAAsB;CACtB,WAAW;CACX,YAAY;AACb;AACA;CACC,SAAS;AACV;AACA;CACC,oBAAoB;AACrB;AACA;;CAEC,WAAW;CACX,YAAY;CACZ,oBAAoB;AACrB;AACA;CACC,2CAA2C;CAC3C,sCAAsC;AACvC;AACA;CACC,eAAe;CACf,iBAAiB;CACjB,kCAAkC;CAClC,gBAAgB;CAChB,yBAAyB;AAC1B;;AAEA;CACC,iBAAiB;CACjB,cAAc;CACd,0BAA0B;CAC1B,mBAAmB;CACnB,kBAAkB;CAClB,0BAA0B;CAC1B,qBAAqB;AACtB","sourcesContent":[".DatePickerComponent_otr {\n\tdisplay: flex;\n\tmin-height: 380px;\n}\n.DatePickerComponent_otr .react-datepicker {\n\tborder: none;\n\tborder-radius: 0;\n\t-webkit-border-radius: 0;\n\t-moz-border-radius: 0;\n\t-ms-border-radius: 0;\n\t-o-border-radius: 0;\n}\n.DatePickerComponent_otr .react-datepicker__header {\n\tpadding: 0;\n}\n\n.react-datepicker__day--disabled {\n\tpointer-events: none;\n}\n.DatePickerComponent_otr .react-datepicker,\n.DatePickerComponent_otr .react-datepicker__month-container,\n.DatePickerComponent_otr .react-datepicker__day-name,\n.DatePickerComponent_otr .react-datepicker__day {\n\twidth: 100%;\n}\n.DatePickerComponent_otr .react-datepicker__day-names,\n.DatePickerComponent_otr .react-datepicker__week {\n\tdisplay: flex;\n\talign-items: stretch;\n}\n.DatePickerComponent_otr .react-datepicker__day-name,\n.DatePickerComponent_otr .react-datepicker__month,\n.DatePickerComponent_otr .react-datepicker__day,\n.DatePickerComponent_otr .react-datepicker__day-names {\n\tmargin: 0;\n}\n.DatePickerComponent_otr .react-datepicker__header {\n\tbackground-color: transparent;\n\tborder: none;\n\tborder-radius: 0;\n\t-webkit-border-radius: 0;\n\t-moz-border-radius: 0;\n\t-ms-border-radius: 0;\n\t-o-border-radius: 0;\n}\n.DatePickerComponent_otr .react-datepicker__current-month {\n\tfont-size: 32px;\n\tline-height: 44px;\n\tfont-family: Verdana !important;\n\tfont-weight: 300;\n\tpadding: 16px 8px;\n\tcolor: var(--dark-text-color);\n}\n.DatePickerComponent_otr .react-datepicker__navigation {\n\twidth: 44px;\n\theight: 44px;\n\ttop: 16px;\n}\n.DatePickerComponent_otr .react-datepicker__navigation-icon {\n\ttop: 2px;\n}\n.DatePickerComponent_otr .react-datepicker__navigation--previous {\n\tleft: 90px;\n}\n@media (max-width: 575px) {\n\t.DatePickerComponent_otr .react-datepicker__navigation--previous {\n\t\tleft: 50px;\n\t}\n}\n@media (max-width: 450px) {\n\t.DatePickerComponent_otr .react-datepicker__navigation--previous {\n\t\tleft: 30px;\n\t}\n}\n@media (max-width: 390px) {\n\t.DatePickerComponent_otr .react-datepicker__navigation--previous {\n\t\tleft: 10px;\n\t}\n}\n.DatePickerComponent_otr .react-datepicker__navigation--next {\n\tright: 90px;\n}\n@media (max-width: 575px) {\n\t.DatePickerComponent_otr .react-datepicker__navigation--next {\n\t\tright: 50px;\n\t}\n}\n@media (max-width: 450px) {\n\t.DatePickerComponent_otr .react-datepicker__navigation--next {\n\t\tright: 30px;\n\t}\n}\n@media (max-width: 390px) {\n\t.DatePickerComponent_otr .react-datepicker__navigation--next {\n\t\tright: 10px;\n\t}\n}\n.DatePickerComponent_otr .react-datepicker__month {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 10px 0;\n\tpadding: 10px 0 24px 0;\n}\n\n.DatePickerComponent_otr .react-datepicker__day-name {\n\tfont-size: 12px;\n\tline-height: 28px;\n\tfont-weight: 500;\n\tfont-family: Verdana !important;\n\tcolor: var(--black-color);\n}\n.DatePickerComponent_otr .react-datepicker__day {\n\tposition: relative;\n\tfont-size: 16px;\n\tline-height: 32px;\n\tfont-family: Verdana !important;\n\tfont-weight: 500;\n\tz-index: 2;\n\ttransition: 0.3s;\n\t-webkit-transition: 0.3s;\n\t-moz-transition: 0.3s;\n\t-ms-transition: 0.3s;\n\t-o-transition: 0.3s;\n}\n.DatePickerComponent_otr .react-datepicker__day:hover::after {\n\tbackground-color: var(--primary-color);\n}\n.DatePickerComponent_otr .react-datepicker__day::after {\n\tcontent: \"\";\n\tposition: absolute;\n\twidth: 32px;\n\theight: 32px;\n\ttop: 50%;\n\tleft: 50%;\n\ttransform: translate(-50%, -50%);\n\t-webkit-transform: translate(-50%, -50%);\n\t-moz-transform: translate(-50%, -50%);\n\t-ms-transform: translate(-50%, -50%);\n\t-o-transform: translate(-50%, -50%);\n\tborder-radius: 100%;\n\t-webkit-border-radius: 100%;\n\t-moz-border-radius: 100%;\n\t-ms-border-radius: 100%;\n\t-o-border-radius: 100%;\n\ttransition: 0.3s;\n\t-webkit-transition: 0.3s;\n\t-moz-transition: 0.3s;\n\t-ms-transition: 0.3s;\n\t-o-transition: 0.3s;\n\tbackground-color: transparent;\n\tz-index: -1;\n}\n.DatePickerComponent_otr .react-datepicker__day--selected::after {\n\tbackground-color: var(--primary-color);\n}\n.DatePickerComponent_otr .react-datepicker__day:hover,\n.DatePickerComponent_otr .react-datepicker__day--selected,\n.react-datepicker__day--keyboard-selected,\n.react-datepicker__month-text--keyboard-selected,\n.react-datepicker__quarter-text--keyboard-selected,\n.react-datepicker__year-text--keyboard-selected {\n\tbackground: transparent !important;\n}\n.DatePickerComponent_otr .react-datepicker__day:hover {\n\tcolor: var(--white-color);\n}\n\n.DatePickerComponent_otr .react-datepicker__day--outside-month {\n\topacity: 0.3;\n}\n\n.AppointmentCalendar_otr {\n\theight: 100%;\n}\n\n.date_radio_otr {\n\tbackground: var(--date-radio-bg);\n\tpadding: 16px 24px;\n\t/* height: calc(100vh - 555px); */\n\tmin-height: calc(100vh - 598px);\n\tmax-height: fit-content;\n}\n.date_radio_otr .date_text {\n\tcolor: var(--desc-color2);\n\tfont-size: 14px;\n\tline-height: 24px;\n\tfont-family: \"Poppins\", sans-serif;\n\tfont-weight: 400;\n\tmargin-bottom: 12px;\n\tletter-spacing: 0.01071em;\n}\n.date_check_group_wrapper {\n\twidth: 100%;\n\toverflow-x: auto;\n}\n.date_radio_otr .radio_check_group {\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\tgap: 20px 0;\n\tmin-width: 450px;\n}\n\n.time_slot_radio_btn_wrapper {\n\twidth: 50%;\n}\n\n.radio_check_group .ant-radio-wrapper {\n\twidth: 100%;\n\tmargin-inline-end: 0 !important;\n}\n@media (max-width: 575px) {\n\t.date_radio_otr {\n\t\tbackground: var(--date-radio-bg);\n\t\tpadding: 16px 24px;\n\t\theight: fit-content;\n\t}\n\n\t.date_radio_otr .radio_check_group {\n\t\tpadding-bottom: 20px;\n\t\tgap: 20px;\n\t}\n\n\t.time_slot_radio_btn_wrapper {\n\t\tbackground-color: #fff;\n\t\tborder-radius: 16px;\n\t\twidth: 215px;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\theight: 55px;\n\t}\n\t.radio_check_group .ant-radio-wrapper {\n\t\twidth: auto;\n\t}\n}\n.radio_check_group .ant-radio-wrapper-checked .ant-radio-inner {\n\tborder: 2px solid var(--primary-color) !important;\n}\n.radio_check_group .ant-radio-wrapper-checked .ant-radio-inner::after {\n\ttop: 50%;\n\tleft: 51%;\n\tbackground-color: var(--primary-color) !important;\n\ttransform: translate(-50%, -50%);\n\t-webkit-transform: translate(-50%, -50%);\n\t-moz-transform: translate(-50%, -50%);\n\t-ms-transform: translate(-50%, -50%);\n\t-o-transform: translate(-50%, -50%);\n\tmargin-block-start: 0;\n\tmargin-inline-start: 0;\n\twidth: 10px;\n\theight: 10px;\n}\n.radio_check_group .ant-radio-wrapper:nth-child(even) .ant-radio-inner::after {\n\tleft: 50%;\n}\n.radio_check_group .ant-radio-wrapper:nth-child(even) {\n\tjustify-content: end;\n}\n.radio_check_group .ant-radio-wrapper .ant-radio-input,\n.radio_check_group .ant-radio-wrapper .ant-radio-inner {\n\twidth: 20px;\n\theight: 20px;\n\tmargin: 0 !important;\n}\n.radio_check_group .ant-radio-wrapper .ant-radio-inner {\n\tborder: 2px solid var(--radio-border-color);\n\tbackground-color: var(--date-radio-bg);\n}\n.radio_check_group .ant-radio-wrapper span:nth-child(2) {\n\tfont-size: 16px;\n\tline-height: 24px;\n\tfont-family: \"Poppins\", sans-serif;\n\tfont-weight: 400;\n\tletter-spacing: 0.00938em;\n}\n\n.noslots_response {\n\tpadding-top: 1rem;\n\tdisplay: block;\n\tfont-size: 1rem !important;\n\tline-height: 1.5rem;\n\tfont-style: italic;\n\tletter-spacing: 0.02957rem;\n\tcolor: rgb(139, 0, 0);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
